import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
//import Breadcrumbs
import { getProfiles,postFileProfile,resourcesAttendances } from '../../helpers/backend_helper';
import {ConfirmAsistencia,ToastHelper,Alert as SwAlert} from '../../helpers/alerts/alertHelper';
import avatar from "../../assets/images/users/avatar.png";
import ValidateFileHelper from '../../helpers/ValidateFileHelper'
import QrReader from "react-qr-reader";
import {CardHeader,Container,Row,Col,Card,CardTitle,Alert,CardBody,Button,Label,Input,FormFeedback,Form} from "reactstrap";

const Profile = () => {
    const [errors, setErrors] = useState({});
    const [image, setImage] = useState(avatar);
    const [selectedCam, setSelectedCam] = useState("environment");
    const [startScan, setStartScan] = useState(false);
    const [loadingScan, setLoadingScan] = useState(false);
    const [data, setData] = useState("");
    const [user, setUser] = useState({
        id:null,
        name: '',
        email: '',
        profile_id: null,
        image:null,
        profile: {
            id: null,
            name: ''
        },
    });

    const getDataUser = async (id) => {
        getProfiles(id).then(response => {
            setUser(response.user)
        })    
    }

    const handleScan = async (scanData) => {
        setLoadingScan(true);
        if (scanData && scanData !== "") {
            setData(scanData);
            let dataUser = JSON.parse(scanData)
            getDataUser(dataUser.id)
            setStartScan(false);
            setLoadingScan(false);
        }
    };

    const handleError = (err) => {
        console.error(err);
    };

    const changeStatus = (id) => {
        if(!user.operator.dateAssist){
            const date = new Date();
            let data = {
                date:date,
                id:id,
                attendance:true
            }
            ConfirmAsistencia(async confirmed => {
                if (!confirmed) { return; }
                resourcesAttendances('post',data).then(response => {
                    getDataUser(user.id)
                    SwAlert('Asistencia registrada correctamente',true)
                })
            },true);
        }else{
            SwAlert('Asistencia ya registrada',false)
        }
    }

    document.title = "Perfil de usuario";
    return (
        <React.Fragment>
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardHeader>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <h3>Lector de codigos Qr</h3>
                                    </div>
                                    <div className="col-sm-2">
                                        <Button color="primary" onClick={()=>setStartScan(true)}>
                                            <i className="fa fa-qrcode" aria-hidden="true"> Escanear Qr</i>
                                        </Button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <div className="row">
                                    <div className="col-sm-12" style={{alignContent: 'center'}}>
                                        <h4>Lector Qr</h4><br/>
                                        <p>Centra el qr en la en el margen que se muestra en la cámara</p>
                                        {startScan &&
                                        <Button color="success" title={selectedCam=='user' ? 'Frontal':'Trasera'} onClick={() => setSelectedCam(selectedCam=='user' ? 'environment':'user')}>
                                            <i className="fa fa-retweet" aria-hidden="true"> Cambio de camara</i>
                                        </Button>
                                        }
                                    </div>
                                    <div className="col-sm-2"></div>
                                    <div className="col-sm-8" style={{alignContent: 'center'}}>
                                        {startScan &&
                                        <QrReader
                                            facingMode={selectedCam}
                                            delay={1000}
                                            onError={handleError}
                                            onScan={handleScan}
                                            style={{ width: "auto" }}
                                        />
                                        }
                                    </div>
                                    {user.profile_id==6 &&
                                    <div className="col-sm-2" style={{alignContent: 'center'}}>
                                        {!user.operator.dateAssist &&
                                        <Button color="success" title='Registrar asistencia' onClick={() => changeStatus(user.operator.id)}>
                                            <i className="fa fa-check-square" aria-hidden="true"> Registrar asistencia</i>
                                        </Button>
                                        }
                                    </div>
                                    }

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            {user.id &&
            <>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                              
                                <div className="d-flex">
                                    <div className="ms-10">
                                        <img
                                            src={user.image ? user.image:avatar}
                                            alt=""
                                            className="avatar-md rounded-circle img-thumbnail"
                                            style={{width:"192px",height:"199px",}}
                                        />
                                    </div>
                                    <div className="flex-grow-1 align-self-center ms-3">
                                        <div className="text-muted">
                                            <h5>{user.name}</h5>
                                            <p className="mb-1">{user.email}</p>
                                            <p className="mb-0">Id no: #{user.id}</p>
                                        </div>
                                    </div>
                                    {user.profile_id==6 &&
                                        <div className="ms-10">
                                        <img
                                            src={user.qr ? user.qr:avatar}
                                            alt=""
                                            style={{width:"200px",height:"200px",}}
                                        />
                                    </div>
                                    }
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <h4 className="card-title mb-4">Información </h4>
                <Card>
                    <CardBody>
                        <div className="row">
                            <div className="col-sm-2">
                                <p className="mb-1">Nombre de Empresa</p>   
                                <h5>{user.company_name}</h5>
                            </div>
                            <div className="col-sm-2">
                                <p className="mb-1">Nombre de Perfil</p>   
                                <h5>{user.profile_name}</h5>
                            </div>
                            <div className="col-sm-8">
                                <p className="mb-2">Cuenta verificada</p>
                                <h5>{user.verified}</h5>
                            </div>

                            {user.profile_id==6 &&
                                    <>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Clave</p>    
                                        <h5>{user.operator.key}</h5>
                                    </div>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Ruta</p>    
                                        <h5>{user.operator.route_name}</h5>
                                    </div>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Numero de unidad</p>    
                                        <h5>{user.operator.unitNo}</h5>
                                    </div>
                                    </>
                                }
                        </div>
                    </CardBody>
                </Card>
                </>
                }
            </Container>
        </div>
    </React.Fragment>
    );
};

export default Profile;
